const { BASE_URL } = require("./client");

const CONNECT_WITH_US = BASE_URL +'/api/connect/get'

module.exports = {
    CONNECT_WITH_US
}